import React, { useEffect, useState } from 'react';

import ManagerLayout from 'components/Layout/Manager/ManagerLayout';
import {
  useCheckImportStatusQuery,
  useImportCustomerMutation,
} from 'thunks/RTKQuery/dealerCustomer';
import { Spinner2 } from 'components';
import { handleRTKResponseToaster } from 'utils/handle-api-response';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { IMPORT_ENTITIES } from 'constants/constants';
import { ImportCustomerComponent } from './component';

export const ImportCustomerContainer = () => {
  const [file, setFile] = useState<File>();
  const [path, setPath] = useState<string>('');
  const [importStatus, setImportStatus] = useState<any>(null);
  const [entityType, setEntityType] = useState<string>(
    IMPORT_ENTITIES.FMCUSTOMERS
  );

  const {
    data: importStatusData = [],
    isLoading: isLoadingImportStatus,
    refetch: refetchImportStatus,
  } = useCheckImportStatusQuery(entityType);

  useEffect(() => {
    if (!importStatusData) return;
    // If importStatusData is an array, do nothing
    if (Array.isArray(importStatusData)) return;
    setImportStatus(importStatusData);
  }, [importStatusData]);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [
    importCustomer,
    { isLoading, error, status },
  ] = useImportCustomerMutation();

  const handleFileChange = (field: string, files: File[]) => {
    if (files.length) {
      const csvFile = files[0] || null;
      setFile(csvFile);
      setPath(csvFile.name);
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    setImportStatus(null);

    const result = await importCustomer({ file, entityType }).unwrap();
    setImportStatus(result);
  };

  useEffect(() => {
    handleRTKResponseToaster(
      status,
      error,
      dispatch,
      t('contract.error'),
      t('dealer.import.title'),
      t('dealer.import.message')
    );
    refetchImportStatus();
  }, [status]);

  return (
    <ManagerLayout>
      <h1>{t('customerManagement.import.heading')}</h1>
      <Spinner2 show={isLoading || isLoadingImportStatus} />
      <hr />
      <ImportCustomerComponent
        file={file}
        path={path}
        importStatus={importStatus}
        handleFileChange={handleFileChange}
        handleUpload={handleUpload}
        isLoading={isLoading}
        entityType={entityType}
        setEntityType={setEntityType}
      />
    </ManagerLayout>
  );
};
